"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyStatusesResponseToJSON = exports.SurveyStatusesResponseFromJSONTyped = exports.SurveyStatusesResponseFromJSON = exports.instanceOfSurveyStatusesResponse = void 0;
var runtime_1 = require("../runtime");
var SurveyStatuses_1 = require("./SurveyStatuses");
/**
 * Check if a given object implements the SurveyStatusesResponse interface.
 */
function instanceOfSurveyStatusesResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyStatusesResponse = instanceOfSurveyStatusesResponse;
function SurveyStatusesResponseFromJSON(json) {
    return SurveyStatusesResponseFromJSONTyped(json, false);
}
exports.SurveyStatusesResponseFromJSON = SurveyStatusesResponseFromJSON;
function SurveyStatusesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isUnderPacing': !(0, runtime_1.exists)(json, 'is_under_pacing') ? undefined : json['is_under_pacing'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (json['status'].map(SurveyStatuses_1.SurveyStatusesFromJSON)),
    };
}
exports.SurveyStatusesResponseFromJSONTyped = SurveyStatusesResponseFromJSONTyped;
function SurveyStatusesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'is_under_pacing': value.isUnderPacing,
        'status': value.status === undefined ? undefined : (value.status.map(SurveyStatuses_1.SurveyStatusesToJSON)),
    };
}
exports.SurveyStatusesResponseToJSON = SurveyStatusesResponseToJSON;
